import Vue from 'vue';
import App from './App.vue';
import './plugins/vuetify';
import router from './router.js';
import store from './store/index.js';
import PageLoading from './plugins/page-loading.vue';
import './filters/index.js';
import fetchLogger from './plugins/fetch-logger.js';

Vue.config.productionTip = false;

Vue.component('page-loading', PageLoading);

if (process.env.VUE_APP_LOG_FETCH) {
  fetchLogger(store, router);
}

document.addEventListener('deviceready', () => {
  cordova.plugins.autoStart.enable();
}, false);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
